import { Observable } from 'rxjs';

import { MatDialogRef } from '@angular/material/dialog';

import { SnMapClusterPoint } from '@lib/api';
import { SnAlarm, SnCamera, SnUserSettings } from '@lib/api/entities';

export interface AlarmSelectionEvent {
  alarm: SnAlarm;
  cameras: SnCamera[];
  action?: string;
}

export interface AlarmMapQueryParams {
  pageMapClustered: boolean;
  pageMapGridSize: number;
  pageMapZoomLevel: number;
  pageMapLeftTop: string;
  pageMapRightBottom: string;
  type_name__not_in: string;
  message__not_in: string;
}

export interface AlarmQueryParams {
  mapQueryParams: Partial<AlarmMapQueryParams>;
  filteredTypes: string[];
  filteredReasons: string[];
}
export interface PopupRequestEvent {
  alarm: SnAlarm;
  coordinates?: [number, number];
}

export interface CameraLayerObject {
  camera_id: string;
  data?: {
    geometry?: {
      coordinates: [number, number];
    };
  };
  [key: string]: unknown;
}

export interface AlarmsServiceInterface {
  alarms$: Observable<SnAlarm[]>;
  clusteredAlarms$: Observable<SnMapClusterPoint[]>;
  viewAlarmDetails$: Observable<SnAlarm>;
  requestPopupOpen$: Observable<PopupRequestEvent>;
  requestNavigation$: Observable<{ alarm: SnAlarm; coordinates?: [number, number] }>;
  selectedAlarm$: Observable<{ alarm: SnAlarm; cameras: SnCamera[]; action?: string }>;
  isSlewing$: Observable<boolean>;
  alertClustering$: Observable<boolean>;
  isToggled$: Observable<boolean>;
  settings$: Observable<SnUserSettings | null>;

  // Methods
  initAlarms(params: AlarmQueryParams): void;
  updateMapBounds(mapQueryParams: Partial<AlarmMapQueryParams>): void;
  setIsSlewing(isSlewing: boolean): void;
  setAlertClustering(enabled: boolean): void;
  setIsToggled(isToggled: boolean): void;
  setSettings(settings: SnUserSettings): void;
  isSelected(alarmId: string): boolean;
  select(
    id: string,
    action?: string,
    cameraLayerObjects?: CameraLayerObject[],
  ): Observable<{ alarm: SnAlarm; cameras: SnCamera[]; action?: string }>;
  viewAlarmDetails(id: string): void;

  // Properties
  alarmDialogs: MatDialogRef<unknown>[];
  alarms: SnAlarm[];
  clusteredAlarms: SnMapClusterPoint[];
  
  // Getters for facade access
  selectedAlarm: SnAlarm | null;
  isSlewing: boolean;
  alertClustering: boolean;
  isToggled: boolean;
  settingsValue: SnUserSettings | null;
}
